<template>
    <div class="ad-card mdc-card" v-on:click="onClick(ad.action_link)">
        <div class="corner-ribbon top-left shadow primary-theme">廣告</div>
        <div class="mdc-card__primary-action">
            <div class="mdc-card__media">
                <img class="cover-photo" :src="ad.advertise_photos[0].url" alt="cover"/>
            </div>
            <div class="popsale-card__primary">
                <h2 class="mdc-typography mdc-typography--headline6">{{ ad.title }}</h2>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            ad: Object,
            required: true
        },
        data: function () {
            return {
                'masonry': null,
            }
        },
        methods: {
            onClick: function (url) {
                window.open(url);
            }
        },
        mounted() {
            this.masonry = $('.popsale-ad-side').masonry();

            this.masonry.append(this.$el).masonry('appended', this.$el);

            $(this.$el).imagesLoaded(function () {
                this.masonry.masonry('layout')
            }.bind(this));
        }
    }
</script>

